"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loading;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useTranslation = _interopRequireDefault(require("../../../hooks/useTranslation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @ts-ignore: Unreachable code error

function Loading() {
  var t = (0, _useTranslation.default)();
  var text = t('loading');
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    paddingLevel: 6,
    dataAttributes: {
      'data-testid': 'loading-spinner'
    },
    elevation: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
    text: text,
    srText: text,
    size: 1
  }));
}